var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',[_c('v-textarea',{attrs:{"full-width":"","single-line":"","label":"Obs.:","value":_vm.agendamento.observacao},on:{"input":function($event){return _vm.updateAtributoAgendamento({
          valor: $event,
          nomeAtributo: 'observacao',
        })}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }